/*****************************************************************************
 * Component: items */
/**
 * @ngdoc     component
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.component:items
 * @description
 * Component definition object for {@link items}. The component is used to
 * manage items content in the Item Costs, Fixed Items and Item Sales tabs.
 *****************************************************************************/
export const itemsComponent = {
  require: { dialogCtrl: '^^fundraiserItemsDialog' },
  template: '<fund-items grid-data="$ctrl.gridData"></fund-items>',
  controller: ItemController
}

/*****************************************************************************
 * Controller: ItemController */
/**
 * @ngdoc     controller
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.items.controller:ItemController
 * @description
 * Main controller for {@link items}
 *****************************************************************************/
/* @ngInject */ function ItemController($injector, $scope) {
  var $ctrl = this;
  $ctrl.$onInit = $injector.invoke($onInit, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.setNonSaleCostItems = $injector.invoke(setNonSaleCostItems, null, {
    $ctrl: $ctrl
  });
  $ctrl.updateGridSource = $injector.invoke(updateGridSource, null, {
    $ctrl: $ctrl
  });
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc    function
 * @name     $onInit
 * @methodOf csm.books.fundraisers.items.controller:ItemController
 * @description
 * Initialization callback function. The required dialogCtrl will be available
 * at this point for initialization purposes.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl, $scope, Tools) {
  return function () {
    /*-----------------------------------------------*/
    /* Register a watch in here in $onInit when the  */
    /* dialogCtrl becomes available. When the active */
    /* tab changes, update the grid's dataprovider.  */
    /*-----------------------------------------------*/
    $scope.$watch(
      function () {
        return $ctrl.dialogCtrl.getTabType();
      },
      function (tab) {
        $ctrl.updateGridSource();
      }
    );

    /*---------------------------------------------------------------*/
    /* Register a watch on the sum of the current grid's fund item   */
    /* subtotals. When the sum changes, calculate the fund items     */
    /* total amount to be displayed and update the summary tab data. */
    /*---------------------------------------------------------------*/
    $scope.$watch(
      function () {
        return ($ctrl.gridData || []).reduce(function (total, item) {
          return (total += item.subtotal);
        }, 0);
      },
      function (newSubtotal, oldSubtotal) {
        /*-------------------------------------------------*/
        /* Update the fund item total and summary tab      */
        /* data, and update the list of unsold cost items. */
        /*-------------------------------------------------*/
        $ctrl.fundItemTotal = Tools.roundMoney(newSubtotal);
        $ctrl.dialogCtrl.setSummaryTotals();
        $ctrl.setNonSaleCostItems();
      }
    );
  };
}

/*****************************************************************************
 * setNonSaleCostItems */
/**
 * @ngdoc    function
 * @name     setNonSaleCostItems
 * @methodOf csm.books.fundraisers.items.controller:ItemController
 * @description
 * Sets the dpItemCostsNotSold list from the item costs list that don't have
 * a corresponding sale item set up. As the items are currently anonymous
 * objects in our db, the only way we can compare is by the name.
 *****************************************************************************/
/* @ngInject */ function setNonSaleCostItems($ctrl) {
  return function () {
    $ctrl.dialogCtrl.dpItemCostsNotSold = $ctrl.dialogCtrl.dpItemCosts.filter(
      function (e) {
        for (var ii = 0; ii < $ctrl.dialogCtrl.dpItemSales.length; ii++)
          if ($ctrl.dialogCtrl.dpItemSales[ii].itemName == e.itemName)
            return false;

        return true;
      }
    );
  };
}

/*****************************************************************************
 * updateGridSource */
/**
 * @ngdoc    function
 * @name     updateGridSource
 * @methodOf csm.books.fundraisers.items.controller:ItemController
 * @description
 * Set the grid dataprovider based on the current active tab.
 *****************************************************************************/
/* @ngInject */ function updateGridSource($ctrl, TabType) {
  return function () {
    /*------------------------------------------*/
    /* Summary tab has no grid to update, skip. */
    /*------------------------------------------*/
    if ($ctrl.dialogCtrl.getTabType() === TabType.SUMMARY) return;

    /*---------------------------*/
    /* Update grid dataprovider. */
    /*---------------------------*/
    $ctrl.gridData =
      $ctrl.dialogCtrl.getTabType() == TabType.ITEM_COSTS
        ? $ctrl.dialogCtrl.dpItemCosts
        : $ctrl.dialogCtrl.getTabType() == TabType.FIXED_ITEMS
          ? $ctrl.dialogCtrl.dpFixedItems
          : $ctrl.dialogCtrl.dpItemSales;
  };
}
